import { render, staticRenderFns } from "./WelcomeContainer.vue?vue&type=template&id=dcfb1288&scoped=true"
import script from "./WelcomeContainer.vue?vue&type=script&lang=ts"
export * from "./WelcomeContainer.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeContainer.vue?vue&type=style&index=0&id=dcfb1288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfb1288",
  null
  
)

export default component.exports